import { getHeaderHeight } from '#common/components/utils'

function getCoords(elem) {
  // Cross-browser version
  const box = elem.getBoundingClientRect()
  const body = document.body
  const docEl = document.documentElement
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft
  const clientTop = docEl.clientTop || body.clientTop || 0
  const clientLeft = docEl.clientLeft || body.clientLeft || 0
  const top = box.top + scrollTop - clientTop
  const left = box.left + scrollLeft - clientLeft
  return { top: Math.round(top), left: Math.round(left) }
}

export const scrollToError = ($nextTick) => {
  $nextTick(() => {
    const modalElement = document.querySelector('.modal')
    let offset = null
    const formulateErrorElement = document.querySelector(
      '.formulate-input-errors',
    )
    const errorComponent = document.querySelector('.error-component')

    if (formulateErrorElement) {
      offset = getCoords(formulateErrorElement) || null
    } else if (errorComponent) {
      offset = getCoords(errorComponent) || null
    }
    if (offset) {
      if (modalElement) {
        const modalStyle = window.getComputedStyle(modalElement)
        if (modalStyle.display !== 'none') {
          modalElement.scollTop = offset
          return
        }
      }
      window.scrollTo({
        top: offset.top - getHeaderHeight() - 80,
      })
    }
  })
}

export const scrollToElement = ($nextTick, selector) => {
  const element = document.querySelector(selector)
  if (!element) return

  const coords = getCoords(element)
  console.log('scrolling to', selector, coords)
  $nextTick(() =>
    window.scrollTo({
      top: coords.top,
      behavior: 'smooth',
    }),
  )
}

export const pageOffset = (el) => {
  // Get the top, left coordinates of the element
  return el.getBoundingClientRect().top
}
